<template>
  <div
    class="comment mt5"
    :class="{ 'from-current': currentTeam && comment.team == currentTeam.id }"
  >
    <div class="comment-wrapper">
      <div class="team">
        <span class="team-name">{{ decodeHTML(comment.teamName) }}</span>
        <span class="date">{{ dispDate }}</span>
      </div>
      <EditableLabel
        v-model="comment.text"
        class="comment__content"
        use-textarea
        :disabled="comment.team != App.user.id"
        @input="$emit('edit', comment)"
      />
      <button
        v-if="comment.team == App.user.id"
        class="add-button"
        @click="$emit('delete', comment)"
      >
        <img src="/images/delete.png" alt="">
        {{ $t('message.DELETE') }}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Comment item
 *
 * @vue-prop {Object} comment - Comment object to display
 */

// Components
import EditableLabel from '@/components/editable-label.vue';
// Utils
import { decodeHTML } from '@/utils/main';

export default {
  name: 'Comment',

  components: {
    EditableLabel,
  },

  props: {
    comment: {
      type: Object,
      required: true,
    },
  },

  computed: {
    noDate() {
      return this.comment.created === null;
    },
    dispDate() {
      if (this.noDate) {
        return '';
      }
      return this.$moment(this.comment.created).format(this.$t('fullDateTimeFormat'));
    },
  },

  methods: {
    decodeHTML,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.comment {
  text-align: left;

  .comment-wrapper {
    width: 80%;
    display: inline-block;

    .add-button {
      display: inline-flex;
      transform: scale(0.8) translate(5px, -5px);
      padding-right: 0px;
    }

    .team {
      font-size: 0.8em;
      color: #2A5A91;
      display: flex;
      justify-content: space-between;

      .team-name {
        font-weight: 600;
      }
      .date {
      }
    }
  }

  &__content {
    margin: .3rem 0;
  }

  &.from-current {
    text-align: right;
  }
}

</style>
